import { SHOW_ANIMAL_DETAIL_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { HIDE_ANIMAL_DETAIL_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { LOAD_ANIMAL_DETAIL_PROTECTORA } from '../../Animal/actions/actionsAnimal'
import { LOAD_PROTECTORA_DETAIL_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { CHANGE_INFO_ANIMAL_DETAIL_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { MODE_EMAIL_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { MODE_EMAIL_PROTECTORA_2 } from '../../AnimalList/actions/actionsAnimalList'


const initialState = {
	showAnimalDetail: false,
	index: -1,
    indexRow: -1,
	infoAnimalDetail: {},
    infoProtectoraDetail: {},
	tabInfoDetail: 0,
    modeEmail: false,
    modeEmail_2: false
};

export function reducerAnimalDetailProtectora(state = initialState, action) {

	switch (action.type) {
		case SHOW_ANIMAL_DETAIL_PROTECTORA:
			return Object.assign({}, state, {
				showAnimalDetail: action.payload.show,
				index: action.payload.index,
				indexRow: action.payload.indexRow,
				id: action.payload.id,
				tabInfoDetail: 0
			});
        case HIDE_ANIMAL_DETAIL_PROTECTORA:
            return Object.assign({}, state, {
                showAnimalDetail: action.payload.show,
				infoAnimalDetail: action.payload.infoAnimalDetail
            });
        case LOAD_ANIMAL_DETAIL_PROTECTORA:
            return Object.assign({}, state, {
                infoAnimalDetail: action.payload.infoAnimalDetail
            });
        case LOAD_PROTECTORA_DETAIL_PROTECTORA:
            return Object.assign({}, state, {
                infoProtectoraDetail: action.payload.infoProtectoraDetail
            });
        case CHANGE_INFO_ANIMAL_DETAIL_PROTECTORA:
            return Object.assign({}, state, {
                tabInfoDetail: action.payload.tabInfoDetail
            });
        case MODE_EMAIL_PROTECTORA:
            return Object.assign({}, state, {
                modeEmail: action.payload.modeEmail
            });
        case MODE_EMAIL_PROTECTORA_2:
            return Object.assign({}, state, {
                modeEmail_2: action.payload.modeEmail_2
            });
		default:
			return state
	}
}